// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"229":"ab2f5608","243":"99aa490a","572":"96442827","772":"f40c0bc5","941":"43c0732d","980":"5d67a7ea"}[chunkId] + ".js";
};